export default __webpack_public_path__ + "static/media/KOME Suit - Business Analysis & Project Management Practice Lead.9e189ea6.png";